import React, { useState } from 'react';
import { Marker } from "@react-google-maps/api";
import { getAssetPath } from 'app/utils/appHelpers';
import { ASSET_IMAGES } from 'app/utils/constants/paths';
import { CANCELLED_MARKER_COLOR } from 'app/utils/mapMarkers';

const CustomMarker = (props) => {
    const [dialogPosition, setDialogPosition] = useState({top: 0, left: 0})
    const {id, lat, lng, kind} = props;

    // const MarkerDetails = () => {
    //     return (
    //         <Div sx={{display: 'absolute', width: '100px', top: dialogPosition.top, left: dialogPosition.left}}>
                
    //         </Div>
    //     )
    // }

    const markerImg = () => {
        if(kind === 'base') {
            return `base.png`
        } else if(kind === 'in_progress') {
            return `delivery-in-progress.png`
        } else if(kind === 'finished') {
            return `delivery-ended40.svg`
        } else {
            return `delivery-pending.png`
        }
    }

    const cancelledIcon = () => {
        const icon = {
            path: "M0 -20C-3.87 -20 -7 -16.87 -7 -13c0 5.25 7 13 7 13s7 -7.75 7 -13c0 -3.87 -3.13 -7 -7 -7z",
            fillColor: CANCELLED_MARKER_COLOR,
            fillOpacity: 1,
            strokeColor: "#ffffff",
            strokeWeight: 3,
            scale: 1.8,
        };

        if (window.google?.maps?.Point) {
            icon.labelOrigin = new window.google.maps.Point(0, -12);
        }

        return icon;
    };

    const markerIcon = () => {
        if (kind === 'cancelled') {
            return cancelledIcon();
        }

        return getAssetPath(`${ASSET_IMAGES}/map-markers/${markerImg()}`);
    };

    // const onMarkerClick = (evt) => {
    // };
    const onMarkerOver = (evt) => {
    };

    return (
        <React.Fragment>
            <Marker
                // onClick={onMarkerClick}
                icon={markerIcon()}
                position={{ lat: lat, lng: lng }}
                onMouseOver={onMarkerOver}
                {...props}
            />
        </React.Fragment>
    );
};

export default CustomMarker;
